import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {Row, Col} from 'react-flexbox-grid/lib';
import {Card, CardText, CardMedia} from 'material-ui/Card';
import globalStyles from 'layouts/material-admin/globalStyles';

/**
 * theme styles - material admin
 */import styles from './styles/LinkToBoxStyles';

class LinkToBox extends React.Component {

  render() {
    const {title, body, icon, linkTo, backGroundColor } = this.props;

    return (
      <Row>
          <Col xs={12} sm={4} md={4} lg={2} style={{background: 'white'}} >
            <Link to={linkTo} >
              <Card initiallyExpanded={true} style={styles.noBorder}>
                  <CardMedia style={styles.mediaContainer} >
                    <img src={icon} alt="crashboxx" />
                  </CardMedia>
              </Card>
            </Link>


          </Col>
          <Col xs={12} sm={8} md={8} lg={10} style={{background: backGroundColor , color: 'white', height: 190}} >
            <Link to={linkTo} >
              <Card initiallyExpanded={true} style={styles.noBorder} >
                  <CardText style={{minHeight: 150, color: 'white'}} >
                    <h2 style={globalStyles.h2} >{title}</h2>
                    <span>{body}</span>
                  </CardText>
              </Card>
            </Link>

          </Col>
        </Row>
      );
  }
}

LinkToBox.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  linkTo: PropTypes.string.isRequired
};

export default LinkToBox;



// WEBPACK FOOTER //
// ./src/components/dashboard/LinkToBox.js